<div
  *ngIf="timeoutMessageIsVisible"
  class="modal-backdrop show"
  style="z-index: 1055"
></div>
<div
  *ngIf="timeoutMessageIsVisible"
  class="modal show fade"
  id="myModal"
  role="dialog"
  style="z-index: 1060"
>
  <div class="modal-dialog modal-lg" style="z-index: 1060">
    <div class="modal-content">
      <div class="modal-header mx-3 ps-0">
        <h2 class="modal-title text-primary fw-bold" *ngIf="sessionTimedOut">
          ALERT: SESSION HAS ENDED
        </h2>
        <h2 class="modal-title text-primary fw-bold" *ngIf="!sessionTimedOut">
          ALERT: SESSION TIMEOUT WARNING
        </h2>
      </div>
      <div class="modal-body p-3">
        <h3 *ngIf="sessionTimedOut">
          Your session has ended due to no activity on this screen. Please
          re-enter your details, as currently there is no SAVE option.
        </h3>
        <h3 *ngIf="!sessionTimedOut">
          Your session will timeout in 2 min, due to no activity on this screen.
          If you wish to continue your session please click CONTINUE to keep
          your session active.
        </h3>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary float-end mb-0 me-0"
          (click)="endSession()"
          *ngIf="sessionTimedOut"
        >
          EXIT
          <span class="arrow right"> <i class="fa fa-chevron-right"></i></span>
        </button>
        <button
          type="button"
          class="btn btn-primary float-end mb-0 me-0"
          (click)="continueSession()"
          *ngIf="!sessionTimedOut"
        >
          CONTINUE
          <span class="arrow right"> <i class="fa fa-chevron-right"></i></span>
        </button>
      </div>
    </div>
  </div>
</div>
